// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2q0iC","buttons":"RemoveExpirationActionButtons_buttons__UitJw"};